// import * as R from 'ramda';
// import { moment } from '@/plugins/moment';

export default {
};
